import * as React from 'react'

import { Box, CollapsableCard, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import AttendanceSettingForm from 'modules/attendance/lib/forms/AttendanceSettingForm'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import useUpdateAttendanceSetting from '../hooks/useUpdateAttendanceSetting'

interface Props {
  attendanceSetting: AttendanceSetting
}

const createSettingForm = (setting: AttendanceSetting) =>
  new AttendanceSettingForm({
    autofill_timesheet: setting.attributes.autofill_timesheet,
  })

const AutofillTimesheet = ({ attendanceSetting }: Props) => {
  const [settingForm, setSettingForm] = React.useState(createSettingForm(attendanceSetting))
  const autofillTimesheetField = settingForm.get('autofill_timesheet')
  const { updateSetting } = useUpdateAttendanceSetting(settingForm, attendanceSetting)

  useEffect(() => {
    setSettingForm(createSettingForm(attendanceSetting))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attendanceSetting.attributes.id])

  const onChange = (newValue: boolean) => {
    autofillTimesheetField.set(newValue)
    updateSetting()
  }

  return (
    <CollapsableCard
      open={false}
      Card={
        <Box gap="s8">
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="medium">
              {i18n.t('time_tracking.settings.autofill_timesheet.title')}
            </Text.Normal>
            <TogglerCheckbox
              value={autofillTimesheetField.value}
              onChange={(newValue) => onChange(newValue)}
              labelBefore
            />
          </Box>
          <Text.Normal>
            {i18n.t('time_tracking.settings.autofill_timesheet.description')}
          </Text.Normal>
        </Box>
      }
      Content={<></>}
    />
  )
}

export default observer(AutofillTimesheet)
